import React from "react";

const ContentBanner = (
  {
    className = "",
    title = "",
    description = "",
  }
) => {
  return (
    <section className={`content-banner ${className}`}>
      <div className="container">
        <div className="row align-items-end">
          <div className="col-12 col-lg-5 offset-lg-1">
            <div className="content-banner__title-wrapper">
              <h4 className="content-banner__title">{title}</h4>
            </div>
          </div>
          <div className="col-12 col-lg-5 offset-lg-1">
            <div className="content-banner__description-wrapper">
              <p className="content-banner__description">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContentBanner
